import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import SearchForm from '../SearchForm/SearchForm';
import bt from '../../commonStyle.css';
import s from './Layout4.css';

function Layout4(props) {

  const { title, content, bannerImage } = props;

  return (
    <div className={s.bgCss} style={{ backgroundImage: `url(${bannerImage})` }}>
      <div className={s.sectionWidth}>
        <SearchForm id={'layoutFour'} />
        <div>
          <h1 className={cx(s.bannerCaptionText, bt.paddingTop5)}>
            {title}
          </h1>
          <p className={s.bannerCaptionPara}>{content}</p>
        </div>
      </div>
    </div>
  );

}

export default withStyles(bt, s)(Layout4);